import { Link } from "react-router-dom";

// Renders an external <a target=_blank> for http(s) links, an internal <Link> for
// relative paths (/...). Any other/unsafe scheme falls back to "/".
export default function SmartLink({ to, className, children, testid }) {
  const raw = (to || "").trim();
  const isExternal = /^https?:\/\//i.test(raw);
  const isRelative = raw.startsWith("/");
  const safe = isExternal || isRelative ? raw : "/";

  if (isExternal) {
    return (
      <a href={safe} target="_blank" rel="noopener noreferrer" className={className} data-testid={testid}>
        {children}
      </a>
    );
  }
  return (
    <Link to={safe} className={className} data-testid={testid}>
      {children}
    </Link>
  );
}
